import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../state";

export const getBillListById = createAsyncThunk('getBillListById', async (data: any) => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/project/jobnumber/billById?ids=' + data.ids,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const createBilled = createAsyncThunk('createBilled', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/project/jobnumber/billed',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const getTeamList = createAsyncThunk('getTeamList', async () => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/team',
        })
        return response
    } catch (error: any) {
        return error.response
    }
})